export const FOLDER_CREATED = 'Carpeta agregada'
export const FOLDER_UPDATED = 'El nombre de la carpeta fue actualizado'
export const FOLDER_DELETED =
    'La carpeta y todos sus archivos fueron eliminados'
export const FILE_DELETED = 'Archivo eliminado'
export const FILE_UPLOADED = 'Los archivos fueron agregados'

export const MAX_FILES_ALLOWED =
    'Por favor, suba un maximo de 5 archivos por vez'
